// DEF-204 — the one rounder for money, quantities and costs (web copy).
//
// The API keeps a byte-identical copy of the code below the marker line
// (apps/api/src/money/round.ts, where the reasons are written down);
// apps/api/src/money/money-round-copies.test.ts fails if the two drift.
// ---- shared body (keep identical to the web copy) ----
export function roundTo(n: number, places: number): number {
  if (!Number.isFinite(n)) return n
  const f = 10 ** places
  // 15 significant digits drop the binary noise of float arithmetic before rounding
  const r = Math.round(Number((Math.abs(n) * f).toPrecision(15))) / f
  return n < 0 && r !== 0 ? -r : r // half away from zero; never −0
}

export const round2 = (n: number): number => roundTo(n, 2)
export const round3 = (n: number): number => roundTo(n, 3)
export const round4 = (n: number): number => roundTo(n, 4)
// whole cents, by the same rule
export const toCents = (n: number): number => Math.round(round2(n) * 100)
